import { LocaleLangE } from "../i18n/LocaleContext";
import { miningDaysArr } from "@services/auth";
import { getLangFromLocal } from "./lang";

export const localeMiningDays = (
  index: number,
  lang: LocaleLangE = getLangFromLocal()
): string => {
  const ruDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  if (lang === LocaleLangE.RU) return ruDays[index];
  return miningDaysArr[index];
};

const ruDays = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];
const engDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const localeMiningDays2 = (
  day: string[],
  lang: LocaleLangE = getLangFromLocal()
): string[] => {
  const indxs: number[] = [];

  for (let i = 0; i < day.length; i++) {
    const d = day[i];
    const idx = engDays.indexOf(d);
    if (idx < 0) continue;
    indxs.push(idx);
  }
  indxs.sort((a, b) => a - b);
  return indxs.map((x) => (lang === LocaleLangE.RU ? ruDays : engDays)[x]);
};

export const localeMiningDays3 = (
  d: string,
  lang: LocaleLangE = getLangFromLocal()
) => {
  if (isNaN(Number(d))) {
    return d;
  } else {
    return lang === LocaleLangE.RU
      ? ruDays[d as unknown as number]
      : engDays[d as unknown as number];
  }
};
